import React, { Component } from 'react';
import {I18n} from '../../../I18n/components/person';
import translate from '../../../helpers/LanguageModel';
import {Card, CardTitle} from 'reactstrap';
import PaginationList from '../../PaginationList/PaginationList';
import CardSubtitle from 'reactstrap/es/CardSubtitle';
import './personalPackagesList.css';

class PersonPackagesList extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    generateList = items => {
        return items.map(item => {
            return (
                <Card
                    className="packageItem"
                    key={item.id}
                    onClick={item.retailMarketItems.length ? (
                        () => {this.props.changeLocation(`/dashboard/person/packages/${item.id}`)}
                        ) : (() => {})
                    }
                >
                    <CardTitle>{item.name}</CardTitle>
                    <CardSubtitle>{translate('APPS')} : {item.retailMarketItems.length}</CardSubtitle>
                </Card>
            )
        });
    };

    render() {
        return (
            <div className="personalPackagesList">
                <div className="personalPackagesList__content">
                    {this.generateList(this.props.data)}
                </div>
                <PaginationList
                    totalPages={this.props.totalPages}
                    currentPage={this.props.currentPage}
                    paginatedList={this.props.paginatedList}
                    setCurrentPage={this.props.setCurrentPage}
                    setPaginatedList={this.props.setPaginatedList}
                />
            </div>
        )
    }
}

export default PersonPackagesList;



// WEBPACK FOOTER //
// ./src/components/Person/PersonalPackagesList/PersonalPackagesList.js